// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { TextareaTokens } from './type';

const textareaTokens: TextareaTokens = {
  textareaFontSize: 'Font-14',
  textareaFontColor: 'Neutral-text-5',
  textareaBorderRadius: 'Radius-default',
  textareaBorderColor: 'Neutral-border-2',
  textareaPaddingX: 'Spacing-8',
  textareaPaddingY: 'Spacing-4',
  textareaSmallFontSize: 'Font-12',
  textareaSmallPaddingX: 'Spacing-8',
  textareaSmallPaddingY: 'Spacing-1',
  textareaSmallClearSize: 'Font-12',
  textareaLargeFontSize: 'Font-16',
  textareaLargePaddingX: 'Spacing-12',
  textareaLargePaddingY: 'Spacing-7',
  textareaLargeClearSize: 'Font-16',
  textareaPlaceholderColor: 'Neutral-text-2',
  textareaBackgroundColor: 'Neutral-fill-1',
  textareaHoverBorderColor: 'Brand-5',
  textareaFocusBorderColor: 'Brand-7',
  textareaFocusShadow: 'Brand-2',
  textareaDisabledFontColor: 'Neutral-text-2',
  textareaDisabledPlaceholderColor: 'Neutral-text-2',
  textareaDisabledBorderColor: 'Neutral-border-1',
  textareaDisabledBackgroundColor: 'Neutral-fill-2',
  textareaErrorBorderColor: 'Danger-6',
  textareaErrorFocusShadow: 'Danger-1',
  textareaInfoFontColor: 'Brand-6',
  textareaInfoBackgroundColor: 'Neutral-fill-1',
  textareaInfoBorderColor: 'Neutral-border-2',
  textareaInfoErrorFontColor: 'Danger-6',
  textareaInfoErrorBackgroundColor: 'Danger-1',
  textareaInfoErrorBorderColor: 'Danger-6',
  textareaLimitFontColor: 'Neutral-text-3',
  textareaLimitFontSize: 'Font-12',
  textareaClearColor: 'Neutral-text-3',
  textareaClearSize: 'Size-7',
  textareaClearHoverColor: 'Neutral-text-4',
};

export default textareaTokens;
